import { FlexBox } from '@airship-platform/jam-web/components';
import { CloseIcon, PriceTagIcon } from '@airship-platform/jam-web/icons';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

interface AppliedDiscountsItemProps {
  displayName: string;
  disabled?: boolean;
  onClick?: () => void;
}

const AppliedDiscountsItem: React.FC<AppliedDiscountsItemProps> = ({
  displayName,
  disabled,
  onClick,
}) => (
  <FlexBox
    alignItems={'center'}
    userSelect={'none'}
    borderRadius={2}
    border={(theme) => `1px solid ${theme.palette.grey[300]}`}
    px={2}
    py={1.5}
    gap={1.5}
  >
    <FlexBox>
      <PriceTagIcon height={'1.25rem'} width={'1.25rem'} />
    </FlexBox>
    <FlexBox flexDirection={'column'}>
      <Typography variant={'caption'}>{displayName}</Typography>
    </FlexBox>
    {onClick && (
      <IconButton size="small" disabled={disabled} onClick={onClick}>
        <CloseIcon />
      </IconButton>
    )}
  </FlexBox>
);
export default AppliedDiscountsItem;
